import { SeoRenderer } from "../../../common/helpers/seo";
import { getRecentPlans } from "../../store/recentPlans/actions";

import Home from "./loadable";

export default {
    component: Home,
    loadData: ({ dispatch }: any) => {
        return dispatch(getRecentPlans());
    },
    renderSeo: (store: any, allMessage: any, lang: string) => {
        SeoRenderer({ title: `Musicators - ${allMessage.slogen}`, allMessage, lang });
    },
};
